import { faCheckCircle, faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle, Skeleton} from "@mui/material";
import { useScopedField } from "@ngt/forms-core";
import { FC, useEffect, useRef, useState } from "react";
import useAttendanceStatus from "@/hooks/useAttendanceStatus";
import useDebouncedValue from "@/hooks/useDebouncedValue";

interface IUseBoardStatus {
}

const nth = (d: number | undefined) => {
    if (d === undefined) {
        return '';
    }

    if (d > 3 && d < 21) {
        return 'th';
    }

    switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
    }
};

const AttendanceCheck: FC<IUseBoardStatus> = ({
}) => {
    const {state: {value: firstName}} = useScopedField<string>("firstName", {value: true});
    const {state: {value: lastName}} = useScopedField<string>("lastName", {value: true});
    const {context: {setValue: setYearsAttended}} = useScopedField<number>("yearlyAttendanceId", {value: undefined});

    const {state: {value: alreadyRegistered} } = useScopedField<boolean>("alreadyRegistered", {value: true});

    const debouncedFirstName = useDebouncedValue(firstName);
    const debouncedLastName = useDebouncedValue(lastName);
    const { yearsAttended, yearsAttendedId, loading } = useAttendanceStatus(debouncedFirstName ?? undefined, debouncedLastName ?? undefined);

    const [deferredLoading, setDeferredLoading] = useState(false);
    const timerRef = useRef<number>();

    useEffect(() => {
        if (loading) {
            timerRef.current = window.setTimeout(() => {
                setDeferredLoading(true);
            }, 250);
        }
        else {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current)
                timerRef.current = undefined;
            }

            setDeferredLoading(false);
        }
    }, [loading, setDeferredLoading, timerRef])

    useEffect(() => {
        if (yearsAttended && !alreadyRegistered) {
            setYearsAttended(yearsAttendedId);
        }
        
    }, [yearsAttended, yearsAttendedId, alreadyRegistered, setYearsAttended])

    if (deferredLoading && loading) {
        return (
            <Alert
                icon={<FontAwesomeIcon icon={faInfoCircle} />}
                severity="info"
                sx={{
                    alignItems: 'center'
                }}
            >
                <AlertTitle>Attendance Status &ndash; <Skeleton width={120} sx={{display: 'inline-block'}} /></AlertTitle>
                Checking Attendance status...
            </Alert>
        )
    }

    if (firstName && lastName) {
        return (
            <>
                {   
                yearsAttended ? 
                    <Alert
                        icon={<FontAwesomeIcon icon={faCheckCircle} />}
                        severity="success"
                        sx={{
                            alignItems: 'center'
                        }}
                    >
                        <AlertTitle>Yearly Attendance Status</AlertTitle>
                        This will be their <strong>{yearsAttended + 1}{nth(yearsAttended + 1)}</strong> time attending the conference.
                    </Alert>
                    :
                    <Alert
                        icon={<FontAwesomeIcon icon={faCheckCircle} />}
                        severity="success"
                        sx={{
                            alignItems: 'center'
                        }}
                    >
                        <AlertTitle>Yearly Attendance Status</AlertTitle>
                        This will be their first time attending the conference.
                    </Alert>
                }
            </>
        )
    }

    return (
        <Alert
            icon={<FontAwesomeIcon icon={faInfoCircle} />}
            severity="info"
            sx={{
                alignItems: 'center'
            }}
        >
                <AlertTitle>Yearly Attendance Status &ndash; Unknown</AlertTitle>
                Please enter your first and last name.
        </Alert>
    );
}

export default AttendanceCheck;